import Vue from "vue";

export default {
    form(identifier) {
        return Vue.http.get(`form/${identifier}`);
    },
    filledForm(entryId) {
        return Vue.http.get(`form/entry/${entryId}`);
    }
}